import {useEffect, useState} from "react";
import {AboutItem} from "../types/about";
import {openSuccessNotification, showErrorNotification} from "../helpers/mainHelpers";
import {aboutService} from "../services/about-service";
import {useForm} from "antd/es/form/Form";
import {Modal} from "antd";
import {DeleteOutlined} from "@ant-design/icons";

export const useAboutController = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [lastUpdate, setLastUpdate] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [aboutList, setAboutList] = useState<AboutItem[]>([])
  const [selectedAboutItem, setSelectedAboutItem] = useState<AboutItem | undefined>(undefined)
  const [form] = useForm()

  const toggleModal = () => {
    const newValue = !isModalOpen
    if (newValue === false && selectedAboutItem) {
      setSelectedAboutItem(undefined)
      form.resetFields()

    }
    setIsModalOpen(newValue)
  }

  const toggleLastUpdate = () => {
    setLastUpdate(Date.now())
  }

  useEffect(() => {
    fetchAboutItemsList([])
  }, [lastUpdate])

  const confirmDeleteAboutItem = (id: string) => {
    const {confirm} = Modal;
    confirm(
      {
        width: 400,
        icon: <DeleteOutlined/>,
        title: `Видалити запис?`,
        okText: "Видалити",
        okButtonProps: {danger: true},
        cancelText: "Cкасувати",
        onOk: async () => {
          await deleteAboutItemHandler(id)
        },
      });

  }

  const fetchAboutItemsList = async (queries: string[]) => {
    setIsLoading(true)
    try {
      const list = await aboutService.list(queries)
      setAboutList(list)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка при завантаженні інформації!"})
    } finally {
      setIsLoading(false)
    }
  }

  const getAboutItemById = async (id: string) => {
    setIsLoading(true)
    try {
      const currentItem = await aboutService.getById(id)
      setSelectedAboutItem(currentItem)
    } catch (error) {
      console.error(error)
      showErrorNotification({message: "Помилка завантаження запису!"});
    } finally {
      setIsLoading(false)
    }
  }

  const createAboutItemHandler = async (data: AboutItem) => {
    setIsLoading(true)
    try {
      const createdNews = await aboutService.create(data)
      toggleModal()
      toggleLastUpdate()
      openSuccessNotification("Інформація успішно додана!")
    } catch (error) {
      showErrorNotification({message: "Помилка додавання запису інформації!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const updateAboutItemHandler = async (data: AboutItem) => {
    setIsLoading(true)
    try {
      await aboutService.update({$id: selectedAboutItem?.$id, ...data})
      toggleModal()
      toggleLastUpdate()
      openSuccessNotification("Інформація успішно оновлена!")
    } catch (error) {
      showErrorNotification({message: "Помилка оновлення запису інформації!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const deleteAboutItemHandler = async (id: string) => {
    setIsLoading(true)
    try {
      await aboutService.delete(id)
      toggleLastUpdate()
      openSuccessNotification("Запис успішно видалено!")
    } catch (error) {
      showErrorNotification({message: "Помилка видалення запису!", description: JSON.stringify(error)});
    } finally {
      setIsLoading(false)
    }
  }

  const editButtonHandler = (aboutItem: AboutItem) => {
    setSelectedAboutItem(aboutItem)
    toggleModal()
  }

  const submitButtonHandler = async (data: AboutItem) => {
    if (selectedAboutItem) {
      await updateAboutItemHandler(data)
    } else {
      await createAboutItemHandler(data)
    }
  }


  return {
    isLoading,
    aboutList,
    submitButtonHandler,
    isModalOpen,
    selectedAboutItem,
    form,
    toggleModal,
    editButtonHandler,
    confirmDeleteAboutItem,
    getAboutItemById
  }

}